import { render, staticRenderFns } from "./DeepCustomerEmpathy4.vue?vue&type=template&id=a40467ce&scoped=true&"
import script from "./DeepCustomerEmpathy4.vue?vue&type=script&lang=js&"
export * from "./DeepCustomerEmpathy4.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a40467ce",
  null
  
)

export default component.exports